<template>
  <div
    class="the-navbar__user-meta flex items-center"
    v-if="activeUserInfo.firstName"
  >
    <div class="text-right leading-tight hidden sm:block">
      <h6 class="font-semibold">{{ activeUserInfo.firstName }}</h6>
      <h6 class="font-semibold">{{ activeUserInfo.lastName }}</h6>
      <!-- <small>{{$t('profilStatus')}}</small> -->
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          src="../../../../assets/images/portrait/small/Başlıksız-1.png"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 13rem">
          <li
            @click="profil"
            class="
              flex
              py-2
              px-4
              cursor-pointer
              hover:bg-primary
              hover:text-white
            "
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t("profile") }}</span>
          </li>

          <!--<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Inbox</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Tasks</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Chat</span>
          </li>-->

          <li
            @click="popupActive = true"
            class="
              flex
              py-2
              px-4
              cursor-pointer
              hover:bg-primary
              hover:text-white
            "
          >
            <feather-icon icon="KeyIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t("renewPassword") }}</span>
          </li>

          <vs-divider class="m-1" />

          <li
            class="
              flex
              py-2
              px-4
              cursor-pointer
              hover:bg-primary
              hover:text-white
            "
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t("logOut") }}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
    <vs-popup
      classContent="popup-example"
      :title="$t('changePassword')"
      :active.sync="popupActive"
    >
      <div class="container-fluid">
        <div class="row mb-5">
          <div class="col-md-12 orta">
            <vs-input
              class="w-50"
              icon-no-border
              icon="icon icon-unlock"
              icon-pack="feather"
              :label-placeholder="$t('currentPassword')"
              v-model="oldpass"
            ></vs-input>
          </div>
          <div class="col-md-12 orta">
            <vs-input
              class="w-50"
              icon-no-border
              icon="icon icon-unlock"
              icon-pack="feather"
              :label-placeholder="$t('newPassword')"
              v-model="newpass"
            ></vs-input>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-12 orta">
            <vs-button @click="newPassword">{{
              $t("changePassword")
            }}</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { http } from "../../../../http/axios";
import notify from "../../../../shared/toast";
/* eslint-disable */
export default {
  data() {
    return {
      newpass: "",
      oldpass: "",
      popupActive: false,
      obj: {
        FirstName: "",
        LastName: "",
        Email: "",
        UserPassword: "",
      },
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  methods: {
    newPassword() {
      this.obj.FirstName = this.activeUserInfo.firstName;
      this.obj.LastName = this.activeUserInfo.lastName;
      this.obj.Email = this.activeUserInfo.email;
      this.obj.UserPassword = this.newpass;
      let path = "/users/updateprofile";
      http.post(path, this.obj).then((response) => {
        notify.success(this.$t("changedpassword"));
        this.popupActive = false;
      });
    },
    logout() {
      localStorage.clear();
      this.$store.state.token = null;
      this.$store.state.role = "";
      this.$store.state.expiration = "";
      this.$store.state.userId = "";
      //localStorage.removeItem("userInfo");

      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$router.push("/login").catch(() => {});
    },
    profil() {
      this.$router.push("/profil");
    },
  },
};
</script>

<style scoped>
.orta {
  display: flex;
  justify-content: center;
}
</style>
